import { useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Grid,
  Typography,
} from "@mui/material";

import DetailsView from "../Common/Views/DetailsView";
import InventoryStockList from "../Inventory/Stock/InventoryStockList";

const { itemTypeToLabel } = require('./itemUtils');

function ItemDataLayout({ data, reload }) {
  const isProduct = data.type === 'PRODUCT';

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Name
        </Typography>
        <Typography variant="body2">{data.name || "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          UOM
        </Typography>
        <Typography variant="body2">{data.uom || "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Unit price
        </Typography>
        <Chip
          label={`Rs. ${data.unitPrice} / ${data.uom}`}
          variant="outlined"
          color="primary"
          size="small"
          sx={{ px: 1, mx: 0, fontWeight: '500' }}
        />
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Code
        </Typography>
        <Typography variant="body2">{data.code || "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Type
        </Typography>
        <Typography variant="body2">{itemTypeToLabel(data.type)}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Category
        </Typography>
        <Typography variant="body2">{data.category?.name || "-"}</Typography>
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Typography variant="subtitle2" color="text.secondary">
          Status
        </Typography>
        <Typography
          variant="body2"
          color={data.isActive ? 'success.main' : 'warning.main'}
          fontWeight={!data.isActive ? '600' : '400'}
        >
          {data.isActive ? "Active" : "Inactive"}
        </Typography>
      </Grid>

      {isProduct && (
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="subtitle2" color="text.secondary">
            Reorder level
          </Typography>
          <Typography variant="body2">
            {data.reorderLevel != null ? `${data.reorderLevel} ${data.uom}` : "-"}
          </Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="subtitle2" color="text.secondary">
          Description
        </Typography>
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {data.description || "-"}
        </Typography>
      </Grid>
    </Grid>
  )
}



export default function ItemDetails() {
  const { id } = useParams();

  // Determine type path segment from the URL
  const isServiceItem = window.location.pathname.includes('/items/services/');
  const typePathSegment = isServiceItem ? 'services' : 'products';

  return (
    <>
      <DetailsView
        title={isServiceItem ? "Service details" : "Product details"}
        subtitleAttribute="name"
        apiPath={`/tenants/items/${id}`}
        editPath={`/items/${typePathSegment}/${id}/edit`}
        onDelete={(data) => {
          console.log("Delete action for", data);
        }}
      >
        {({ data, reload }) => (
          <>
            <ItemDataLayout data={data} reload={reload} />
          </>
        )}
      </DetailsView>

      {/* Only show inventory stock for non-service items */}
      {!isServiceItem && (
        <Box margin={{ xs: 1, sm: 2 }} mt={{ xs: 2, sm: 4 }} padding={{ xs: 1, sm: 2 }}>
          <InventoryStockList
            filters={{ itemId: id }}
            addButton={true}
            columns={['locationName', 'locationPhoneNo', 'locationAddress', 'actualQuantity', 'reservedQuantity', 'availableQuantity']}
            searchBox={false}
            noResultsMessage="No stock records found for this item"
          />
        </Box>
      )}
    </>
  )
};